import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";

const MobileMenu = ({ scrollTo, setMenuOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleNavClick = (id) => {
    scrollTo(id);
    closeMenu();
  };

  const handleRoute = (path) => {
    closeMenu(() => navigate(path));
  };

  const handleLogout = () => {
    logout();
    toast.success("You have been logged out.");
    closeMenu(() => navigate("/"));
  };

  const closeMenu = (callback) => {
    setIsVisible(false);
    setTimeout(() => {
      setMenuOpen(false);
      if (callback) callback();
    }, 300); // match transition
  };

  return (
    <div className="fixed inset-0 z-[9999]">
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0"}`}
        onClick={() => closeMenu()}
      />

      {/* Slide Panel */}
      <nav
        className={`absolute top-0 left-0 w-full bg-white dark:bg-[#1e293b] shadow-lg transition-transform duration-300 ${
          isVisible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"
        }`}
      >
        <div className="flex flex-col items-start gap-2 py-6 px-6">
          {["hero", "features", "pricing", "faq", "contact"].map((id, index) => (
            <button
              key={id}
              onClick={() => handleNavClick(id)}
              className="w-full text-left text-sm py-2 text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-all duration-200"
              style={{ animation: `fadeIn 0.3s ease ${index * 0.05 + 0.1}s both` }}
            >
              {id === "hero" ? "Home" : id.charAt(0).toUpperCase() + id.slice(1)}
            </button>
          ))}

          {user ? (
            <>
              <button
                onClick={() => handleRoute("/dashboard/vehicles")}
                className="w-full text-left text-orange-500 py-2 hover:bg-orange-100 dark:hover:bg-gray-800 rounded transition duration-200"
                style={{ animation: "fadeIn 0.3s ease 0.4s both" }}
              >
                Dashboard
              </button>
              <div className="text-sm text-gray-600 dark:text-gray-300 w-full mt-2" style={{ animation: "fadeIn 0.3s ease 0.45s both" }}>
                Hello, {user.firstName || user.email}
              </div>
              <button
                onClick={handleLogout}
                className="w-full text-left text-red-600 py-2 hover:bg-red-100 dark:hover:bg-red-900 rounded transition duration-200"
                style={{ animation: "fadeIn 0.3s ease 0.5s both" }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => handleRoute("/auth/signin")}
                className="w-full text-left text-orange-600 py-2 hover:bg-orange-100 dark:hover:bg-gray-800 rounded transition duration-200"
                style={{ animation: "fadeIn 0.3s ease 0.4s both" }}
              >
                Sign In
              </button>
              <button
                onClick={() => handleRoute("/auth/signup")}
                className="w-full text-left text-orange-600 py-2 hover:bg-orange-100 dark:hover:bg-gray-800 rounded transition duration-200"
                style={{ animation: "fadeIn 0.3s ease 0.45s both" }}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      </nav>

      {/* Animations */}
      <style>
        {`
          @keyframes fadeIn {
            0% {
              opacity: 0;
              transform: translateY(10px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default MobileMenu;
